import { ActionGlyph } from '../../components/ActionGlyph'
import { useAppActions, useAppState } from '../../state/AppProvider'
import { AccountScaffold } from './AccountScaffold'

interface EmailNextStepPageProps {
  navigate: (to: string) => void
}

export function EmailNextStepPage({ navigate }: EmailNextStepPageProps) {
  const state = useAppState()
  const actions = useAppActions()

  function continueToTicket() {
    actions.completeEmailNextStep()
    navigate('/onboarding/ticket')
  }

  return (
    <AccountScaffold
      eyebrow="Account · Step 02"
      title="Check your address"
      intro="Make sure the email attached to your account is the one you want to use."
      onBack={() => navigate('/profile')}
      backLabel="Account"
    >
      <section className="access-section" aria-labelledby="email-address-heading">
        <h2 id="email-address-heading">Account email</h2>
        <p className="access-address">{state.user?.email ?? 'No email is attached yet'}</p>
        <p className="access-note">No email has been sent. Confirm the address shown here, then continue to ticket setup.</p>
      </section>
      <div className="access-actions">
        <button className="access-primary" type="button" onClick={continueToTicket}>
          Address looks right
          <ActionGlyph />
        </button>
        <button className="access-secondary" type="button" onClick={() => navigate('/profile')}>
          Update account details
          <ActionGlyph />
        </button>
      </div>
    </AccountScaffold>
  )
}
